import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  title: {
    id: "Appointment.AppointmentEditAddOnsDialog.title",
    defaultMessage: "Edit Add-ons",
  },
  editButton: {
    id: "Appointment.AppointmentEditAddOnsDialog.editButton",
    defaultMessage: "Edit add-ons",
  },
});

const useTranslations = () => {
  const { formatMessage } = useIntl();

  return {
    translations: {
      title: formatMessage(messages.title),
      editButton: formatMessage(messages.editButton),
    },
  };
};

export default useTranslations;
